<template>
  <div>
    <div>
      <div v-if="loaded && adminDestinations.length === 0">
        <div class="alert alert-primary" role="alert">مقصدی یافت نشد.</div>
      </div>
    </div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col align-self="center"
          ><b-form-input
            v-model="searchDestination"
            placeholder="جستجو مقصد بر اساس نام "
            class="mb-3"
            @keypress="notSpace($event)"
            @keydown.enter="updateDestinations"
          ></b-form-input
        ></b-col>
        <b-col align-v="center" align-h="between">
          <button
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
            @click="updateDestinations"
            :disabled="!searchDestination"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button></b-col
        >
        <b-col>
          <div class="d-flex justify-content-end">
            <span class="badge bg-secondary text-white font-size-sm">
              تعداد مقصدها:
              <span dir="ltr" class=" text-white font-size-sm">
                {{ numberFormat(adminDestinationsPagination.total) }}
              </span>
            </span>
          </div></b-col
        >
      </b-row>
    </div>
    <div
      v-if="loaded && adminDestinations.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>نام</th>
                <th>کاربر</th>
                <th>تاریخ</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="destination in adminDestinations"
                :key="destination.id"
              >
                <td>
                  <div class="w-auto btn-clean d-flex px-2">
                    <span class="symbol symbol-25 symbol-light-success">
                      <img
                        :alt="destination.name"
                        :src="
                          `/media/destinations/${
                            destinationTypes[destination.type]
                          }.png`
                        "
                      />
                    </span>
                    <span class="ml-3 font-size-lg pt-1">
                      {{ destination.name }}
                    </span>
                  </div>
                </td>
                <td>
                  <router-link
                    :to="{
                      name: 'admin-users-show',
                      params: { id: destination.user_id }
                    }"
                  >
                    {{ gFullName(destination.user) }}
                  </router-link>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(destination.created_at) }}
                </td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'admin-destinations-show',
                      params: { id: destination.id }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>

                  <button
                    class="btn btn-xs btn-outline-danger mr-1"
                    @click="destroy(destination.id)"
                  >
                    <i class="flaticon2-trash"></i>
                    حذف
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="adminDestinationsPagination.lastPage > 1"
    >
      <b-pagination
        v-model="adminDestinationsPagination.currentPage"
        :total-rows="adminDestinationsPagination.total"
        :per-page="adminDestinationsPagination.perPage"
        aria-controls="my-table"
        @input="updateDestinations()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_DESTINATIONS } from "@/core/services/store/admin/destinations.module";
import { DESTROY_DESTINATION } from "@/core/services/store/destinations.module";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "adminDestinations",
  data() {
    return {
      loaded: false,
      searchDestination: ""
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "مقصد‌ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateDestinations();
  },
  computed: {
    ...mapGetters([
      "currentUserProperty",
      "adminDestinations",
      "adminDestinationsPagination",
      "destinationTypes"
    ])
  },
  methods: {
    updateDestinations() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_ADMIN_DESTINATIONS, this.searchDestination)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    },
    destroy(id) {
      Swal.fire({
        title: "",
        text: "آیا از حذف مقصد اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#1e1f22",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_DESTINATION, id).then(() => {
            this.updateDestinations();
            Swal.fire({
              position: "center",
              icon: "success",
              title: "حذف با موفقیت انجام شد.",
              showConfirmButton: false,
              timer: 1500
            });
          });
        }
      });
    }
  }
};
</script>
